import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-nebraska-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./nebraska-state-form.component.html",
  styleUrl: "./nebraska-state-form.component.scss",
})
export class NebraskaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
